import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { selectCurrentUser } from '../../features/Auth/authSlice';

const LayoutNavigator = () => {
  const user = useSelector(selectCurrentUser);
  return <Navigate to={String(user?.layout)} />;
};

export default LayoutNavigator;
